// extracted by mini-css-extract-plugin
export default {"disclaimer":"TermsOfUse_disclaimer__oIxBt"};